module.exports = __webpack_public_path__ + "static/hero_art-2a114d07bb3f70bf540a73517336488b.svg";